import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';
import { UserObject } from '../../../interfaces/Management.interface';

const profileObjAtom = atom<any>({
  key: RecoilAtomKey.profileObjKey,
  default: {},
});

const createUserFormDataAtom = atom<UserObject>({
  key: RecoilAtomKey.createUserFormDataKey,
  default: {
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    user_code: "",
    username: "",
    mobile: "",
    is_superuser: false,
    groups: [],
    user_permissions: [],
    profile: "",
    location: [],
    user_type: "",
    role: "",
    organisation: null,
    password: "",
    confirm_password: "",
  }
});

const createUserFormDataErrorsAtom = atom<any>({
  key: RecoilAtomKey.createUserFormDataErrorsKey,
  default: {}
});


export { profileObjAtom, createUserFormDataAtom,createUserFormDataErrorsAtom };
